import {
    DataTable,
    DataTableCell,
    DataTableCustomComponent,
    DataTableRow,
    Modal,
    ModalBody,
    ModalFooter,
    Button,
    Page
} from '@7shifts/sous-chef';
import { __ } from 'i18n/translate';
import { Company, Queue, QueueSchedule } from 'adminPanel/types';
import { useCompanyQueues } from 'adminPanel/modules/Companies/hooks/useCompanyQueues';
import { useState } from 'react';

type Props = {
    company: Company;
};

const CompanyQueuesPage = ({ company }: Props) => {
    const { queues, isLoading } = useCompanyQueues(company.id);
    const [schedulesModal, setSchedulesModal] = useState<{
        name: string;
        schedules: QueueSchedule[];
    } | null>(null);

    return (
        <Page
            title={__('adminpanel.queues')}
            breadcrumbs={{ label: __('adminpanel.companies'), url: '../../' }}
        >
            <DataTable
                items={queues}
                isLoading={isLoading}
                itemComponent={(props) => (
                    <QueueRow {...props} onSchedules={setSchedulesModal} />
                )}
                columns={[
                    { name: 'id', label: '#ID', size: 0.15 },
                    { name: 'color', label: 'Cor', size: 0.15 },
                    { name: 'name', label: __('adminpanel.name') },
                    { name: 'schedules', label: 'Horários' }
                ]}
            />

            {schedulesModal && (
                <Modal
                    header={`Horários — ${schedulesModal.name}`}
                    onClose={() => setSchedulesModal(null)}
                >
                    <ModalBody>
                        <table
                            style={{
                                width: '100%',
                                borderCollapse: 'collapse',
                                fontSize: 13
                            }}
                        >
                            <thead>
                                <tr
                                    style={{
                                        background: '#f8f9fa',
                                        textAlign: 'left'
                                    }}
                                >
                                    <th
                                        style={{
                                            padding: '8px 12px',
                                            fontWeight: 600
                                        }}
                                    >
                                        Dia
                                    </th>
                                    <th
                                        style={{
                                            padding: '8px 12px',
                                            fontWeight: 600
                                        }}
                                    >
                                        Início
                                    </th>
                                    <th
                                        style={{
                                            padding: '8px 12px',
                                            fontWeight: 600
                                        }}
                                    >
                                        Fim
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {schedulesModal.schedules.map((s, i) => {
                                    const closed =
                                        s.startTime === '00:00' &&
                                        s.endTime === '00:00';
                                    return (
                                        <tr
                                            key={i}
                                            style={{
                                                borderTop: '1px solid #f1f3f5',
                                                color: closed
                                                    ? '#adb5bd'
                                                    : 'inherit'
                                            }}
                                        >
                                            <td
                                                style={{ padding: '8px 12px' }}
                                            >
                                                {s.weekday}
                                            </td>
                                            <td
                                                style={{ padding: '8px 12px' }}
                                            >
                                                {closed ? '—' : s.startTime}
                                            </td>
                                            <td
                                                style={{ padding: '8px 12px' }}
                                            >
                                                {closed ? '—' : s.endTime}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </ModalBody>
                    <ModalFooter
                        actions={{
                            primary: (
                                <Button
                                    onClick={() => setSchedulesModal(null)}
                                >
                                    Fechar
                                </Button>
                            )
                        }}
                    />
                </Modal>
            )}
        </Page>
    );
};

type QueueRowProps = DataTableCustomComponent<Queue> & {
    onSchedules: (v: { name: string; schedules: QueueSchedule[] }) => void;
};

const QueueRow = ({ item, onSchedules }: QueueRowProps) => {
    const hasSchedules =
        Array.isArray(item.schedules) && item.schedules.length > 0;

    return (
        <DataTableRow>
            <DataTableCell columnIndex={0}>{item.id}</DataTableCell>
            <DataTableCell columnIndex={1}>
                <div
                    style={{
                        width: 20,
                        height: 20,
                        borderRadius: 4,
                        background: item.color,
                        border: '1px solid #dee2e6',
                        display: 'inline-block'
                    }}
                    title={item.color}
                />
            </DataTableCell>
            <DataTableCell columnIndex={2}>{item.name}</DataTableCell>
            <DataTableCell columnIndex={3}>
                {hasSchedules ? (
                    <Button
                        theme="hollow"
                        size="min-width-100"
                        onClick={() =>
                            onSchedules({
                                name: item.name,
                                schedules: item.schedules!
                            })
                        }
                    >
                        Ver
                    </Button>
                ) : (
                    <span style={{ color: '#adb5bd', fontSize: 13 }}>
                        Sem horários
                    </span>
                )}
            </DataTableCell>
        </DataTableRow>
    );
};

export default CompanyQueuesPage;
